import { render, staticRenderFns } from "./AddUserToCognitoModal.vue?vue&type=template&id=01aa7d78&scoped=true&"
import script from "./AddUserToCognitoModal.vue?vue&type=script&lang=ts&"
export * from "./AddUserToCognitoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aa7d78",
  null
  
)

export default component.exports